import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {CacheStore} from './models/cache-store';
import {DefaultRequestCache} from './models/default-request-cache';
import {RequestCache} from './models/request-cache';
import {SessionStorageCacheStore} from './models/session-storage-cache-store';
import {CachingInterceptor} from './services/caching-interceptor';

@NgModule({
    providers: [
        {provide: RequestCache, useClass: DefaultRequestCache},
        {provide: CacheStore, useClass: SessionStorageCacheStore},
        {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true}
    ]
})
export class CachingModule {
}
